export enum DateFilterType {
    Created = 0,
    LastUpdated,
}
